import React from 'react';
import PropTypes from 'prop-types';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
};

export const IconMail = ({size}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    aria-hidden='true'
    {...strokeProps}
  >
    <rect x='3' y='5' width='18' height='14' rx='2' />
    <path d='m3 7 9 6 9-6' />
  </svg>
);

IconMail.propTypes = {
  size: PropTypes.number
};

IconMail.defaultProps = {
  size: 16
};

export const IconCopy = ({size}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    aria-hidden='true'
    {...strokeProps}
  >
    <rect x='9' y='9' width='12' height='12' rx='2' />
    <path d='M5 15V5a2 2 0 0 1 2-2h10' />
  </svg>
);

IconCopy.propTypes = {
  size: PropTypes.number
};

IconCopy.defaultProps = {
  size: 14
};
